// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAxios from 'vue-axios';
import axios from 'axios';
import Lang from 'lang.js';
import { isNil } from 'ramda';

import translations from './settings/Translations';
import Api from './settings/Api';

import List from './List'

var lang = new Lang();
const locale = document.documentElement.lang;

lang.setFallback('es')
lang.setLocale(locale);
lang.setMessages(translations);

Vue.config.productionTip = false

Vue.use(VueAxios, axios);
Vue.use(Api)

Vue.filter('trans', (...args) => {
    return lang.get(...args);
})

const id = !isNil(window.list_data.id)? window.list_data.id : '#app';

/* eslint-disable no-new */
window.list = new Vue({
    el: id,
    data: function() {
        return {
            id: 'list-tours',
            locale: locale,
            root: id
        }
    },
    computed: {
        rootId() {
            return this.root.replace('#', '');
        }
    },
    components: { List },
    template: '<List :root="rootId" :id="id" :locale="locale"/>',
})



// WEBPACK FOOTER //
// ./src/main.js